import type { Session } from 'api';
import { Link } from 'react-router-dom';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Typography } from 'ui';
import { ExpandMore } from 'ui/icons';

import { EvidenceAiGravimetricSessionDetails } from '../EvidenceAiGravimetricSessionDetails/EvidenceAiGravimetricSessionDetails';
import { EvidenceSessionSummary } from '../EvidenceSessionSummary/EvidenceSessionSummary';

export const EvidenceAiGravimetricSession = ({
  session,
  defaultExpanded = false,
  siteMaterialId,
}: {
  defaultExpanded?: boolean;
  session: Session;
  siteMaterialId: number;
}) => {
  const { date, uploaded_by, parent_id, origin, parent_content_type_id } = session;

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <EvidenceSessionSummary date={date} uploadedBy={uploaded_by} origin={origin} showAIBadge={true} />
      </AccordionSummary>
      <AccordionDetails>
        {parent_id && parent_content_type_id ? (
          <EvidenceAiGravimetricSessionDetails
            parentId={parent_id}
            date={date}
            parentContentTypeId={parent_content_type_id}
            uploadedById={uploaded_by?.id || null}
            siteMaterialId={siteMaterialId}
          />
        ) : (
          <Typography>No data</Typography>
        )}
      </AccordionDetails>
      <AccordionActions>
        <Button component={Link} to={`/quality/${siteMaterialId}/sample/${parent_id}/edit`}>
          Edit Sample
        </Button>
      </AccordionActions>
    </Accordion>
  );
};
